import Text from '@components/Text';
import colors from '@constants/colors';
import { ReactNode } from 'react';

import ArrowIcon from './ArrowIcon';
import useSlideHandle, { HANDLE_WIDTH } from './hooks/useSlideHandle';
import useWidth from './hooks/useWidth';
import styles from './styles.module.scss';

interface Props {
    children?: ReactNode;
    onConfirm?: () =>void;
    width?: number | string;
}

function SlideBar({ children, onConfirm, width = '100%' }:Props) {
  const { width: containerWidth, ref } = useWidth();
  const {
    percent, handleTouchEnd, handleTouchStart, handleTouchMove,
    isMoveEnd, translateX,
  } = useSlideHandle({
    containerWidth, onConfirm,
  });
  return (
        <div className={styles.container}
             ref={ref}
             style={{ width }} >
            <Text color={colors.gray5}
                  size='2xl'
                  fontWeight='bold'>
                {children}
            </Text>
            <div className={`${styles.progressWrapper} ${isMoveEnd && styles.moveEnd}`}
                 style={{ width: `calc(${percent * 100}%  + ${HANDLE_WIDTH / 2}px)` }} >
                <div className={styles.progress}
                     style={{ width: containerWidth }} >
                    <Text color={colors.buttonText}
                          size='2xl'
                          fontWeight='bold'>
                        {children}
                    </Text>
                </div>
            </div>
            <div className={`${styles.handle} ${isMoveEnd && styles.moveEnd}`}
                 style={{
                   transform: `translateX(${translateX}px)`,
                 }}
                 onTouchStart={handleTouchStart}
                 onTouchMove={handleTouchMove}
                 onTouchEnd={handleTouchEnd} >
                <ArrowIcon/>
            </div>
        </div>
  );
}

export default SlideBar;
